module.exports = __webpack_public_path__ + "img/cooperative0_logo15.dae99016.jpg";